angular.module('lf.common')

.directive('geoIpMismatchWarningPopup', function ($injector) {
  return function (scope, el, attrs) {
    if (!lf.data.xhr.client.geoIpMismatch) return;
    var popupsServiceName = lf.data.xhr.client.mobileUI ? '$popups' : 'popupsService';
    var popups = $injector.get(popupsServiceName);
    var warningShown = $.cookie('geoIpMismatchWarning');
    if (!warningShown) {
      $.cookie('geoIpMismatchWarning', '1', {path: '/'});
      popups.show('geo-ip-mismatch-warning-popup');
    }
  }
});
